/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = '/users'

const AppUserEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
  ({
    fetchAppUsers: builder.query<any, void>({
      query: () => basePath,
      providesTags: ['appUsers']
    }),

    createAppUser: builder.mutation<any, any>({
      query: (body) => ({
        url: basePath,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['appUsers']
    }),

    toggleAppUserEnabled: builder.mutation<any, number | string>({
      query: (id) => ({
        url: `${basePath}/${id}/toggle-enabled`,
        method: 'POST',
      }),
      invalidatesTags: ['appUsers']
    }),

    resetAppUserPassword: builder.mutation<any, { id: number | string; password: string }>({
      query: ({ id, password }) => ({
        url: `${basePath}/${id}/reset-password`,
        method: 'POST',
        body: { password },
      }),
    }),

    deleteAppUser: builder.mutation<any, number | string>({
      query: (id) => ({
        url: `${basePath}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['appUsers']
    }),
  })

export default AppUserEndpoints
